import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import classes from './Auth.css';
import * as actions from '../../store/actions/index';
import Box from '../../hoc/Box/Box';
import { updateObject, checkValidity } from '../../shared/utility';

class Auth extends Component {
    state = {
        error: false,
        message: 'working...',
        controls: {
            username: {
                elementType: 'input',
                elementConfig: {
                    type: 'username',
                    placeholder: 'Username'
                },
                value: '',
                validation: {
                    required: true,
                    isUsername: true
                },
                valid: false,
                touched: false
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            }
        },
        isSignup: true
    }

    componentDidMount() {
        if (this.props.authRedirectPath !== '/') {
            this.props.onSetAuthRedirectPath();
        }
    }
    componentDidUpdate() {
        if (!this.state.error && this.props.error !== null) {
            const err = this.props.error;
            let msg = err.message || 'Something went wrong';
            if (err.accountNumber) msg += ` | Account: ${err.accountNumber}`;
            if (err.mac) msg += ` | MAC: ${err.mac}`;
            if (err.upstreamUrl) msg += ` | Endpoint: ${err.upstreamUrl}`;
            if (err.error) msg += ` | ${this.getContextualError(err)}`;
            this.setState({
                error: true,
                message: msg
            })
        }
    }

    getContextualError(err) {
        const endpoint = err.upstreamUrl || '';
        const error = err.error || '';

        if (endpoint.includes('get-equipment-details') && error.includes('No managed routers found')) {
            return 'No managed routers were returned from the biller equipment system for this account. The account may not have active router equipment provisioned.';
        }
        if (endpoint.includes('get-equipment-details')) {
            return `Equipment lookup failed: ${error}`;
        }
        return error;
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(this.state.controls, {
            [controlName]: updateObject(this.state.controls[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, this.state.controls[controlName].validation),
                touched: true
            })
        });
        this.setState({ controls: updatedControls });
    }

    submitHandler = (event) => {
        event.preventDefault();
        this.props.onAuth(this.state.controls.username.value, this.state.controls.password.value, this.state.isSignup);
    }

    switchAuthModeHandler = () => {
        this.setState(prevState => {
            return { isSignup: !prevState.isSignup };
        });
    }

    render() {
        let spinner;
        let message;
        if (!this.state.error) {
            spinner = (
                <Spinner />
            )
            message = (
                <div />
            )
        } else {
            spinner = (
                <div />
            )
            message = (
                <div className={classes.Auth}>
                <p>{this.state.message}</p>
                </div>
            )

        }
        return (
            <Box>
                {spinner}
                {message}

            </Box>
        )
        // const formElementsArray = [];
        // for ( let key in this.state.controls ) {
        //     formElementsArray.push( {
        //         id: key,
        //         config: this.state.controls[key]
        //     } );
        // }

        // let form = formElementsArray.map( formElement => (

        //     <Input
        //         key={formElement.id}
        //         elementType={formElement.config.elementType}
        //         elementConfig={formElement.config.elementConfig}
        //         value={formElement.config.value}
        //         invalid={!formElement.config.valid}
        //         shouldValidate={formElement.config.validation}
        //         touched={formElement.config.touched}
        //         changed={( event ) => this.inputChangedHandler( event, formElement.id )} />
        // ) );

        // if ( this.props.loading ) {
        //     form = <Spinner />
        // }

        // let errorMessage = null;    



        // let authRedirect = null;
        // if ( this.props.isAuthenticated  ) {
        //     authRedirect = <Redirect to={this.props.authRedirectPath} />
        // }

        // return (
        //     <div className={classes.Auth}>
        //         {authRedirect}
        //         {errorMessage}
        //         <h2>Log in</h2>
        //         <form onSubmit={this.submitHandler}>
        //             {form}
        //             <Button btnType="Success">SUBMIT</Button>
        //         </form>
        //         {/* <Button
        //             clicked={this.switchAuthModeHandler}
        //             btnType="Primary">Already signed up?  {this.state.isSignup ? 'LOG IN' : 'SIGN UP'}</Button> */}
        //     </div>
        // );

    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null, isPinxt: state.auth.pToken !== null,
        authRedirectPath: state.auth.authRedirectPath,
        pToken: state.auth.pToken
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (username, password, isSignup) => dispatch(actions.auth(username, password, isSignup)),
        onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/'))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
